import React from 'react'

export default function useForceUpdate(): () => void {
  const [, forceUpdate] = React.useState({})

  return React.useCallback(() => {
    forceUpdate({})
  }, [])
}
